// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

function LiveCalls({ liveCallData }) {
  const LiveCalls = liveCallData;

  console.log("LiveCalls Data ;;;;;",LiveCalls)
  return (
    <>
      <div className="font-karla">
        <div className="p-6 ">
          {/* <div className="flex justify-center items-center space-x-4 bg-back-white">
        <button className="flex text-center w-40	h-8 rounded-full border-2 border-gray-400">
          <svg
            width="8"
            height="8"
            viewBox="0 0 8 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="mt-2 mr-2 ml-4"
          >
            <path
              d="M7.33356 0.0027269C7.15681 0.0027269 6.9873 0.072941 6.86232 0.197923C6.73734 0.322904 6.66712 0.492416 6.66712 0.669166V5.72744L1.14234 0.195994C1.01685 0.0705013 0.84664 -1.32228e-09 0.669166 0C0.491692 1.32228e-09 0.321487 0.0705013 0.195994 0.195994C0.0705013 0.321487 1.32228e-09 0.491692 0 0.669166C-1.32228e-09 0.84664 0.0705013 1.01685 0.195994 1.14234L5.72744 6.66712H0.669166C0.492416 6.66712 0.322904 6.73734 0.197923 6.86232C0.072941 6.9873 0.0027269 7.15681 0.0027269 7.33356C0.0027269 7.51031 0.072941 7.67982 0.197923 7.80481C0.322904 7.92979 0.492416 8 0.669166 8H7.33356C7.42065 7.99895 7.50669 7.98083 7.58681 7.94669C7.74965 7.87906 7.87906 7.74965 7.94669 7.58681C7.98083 7.50669 7.99895 7.42065 8 7.33356V0.669166C8 0.492416 7.92979 0.322904 7.80481 0.197923C7.67982 0.072941 7.51031 0.0027269 7.33356 0.0027269Z"
              fill="#697884"
            />
          </svg>
          Incomming
        </button>
        <button className="flex text-center w-40	h-8 rounded-full border-2 border-gray-400">
          <svg
            width="8"
            height="8"
            viewBox="0 0 8 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="mt-2 mr-2 ml-4"
          >
            <path
              d="M0.666439 7.99727C0.84319 7.99727 1.0127 7.92706 1.13768 7.80208C1.26266 7.6771 1.33288 7.50758 1.33288 7.33083V2.27256L6.85766 7.80401C6.98315 7.9295 7.15336 8 7.33083 8C7.50831 8 7.67851 7.9295 7.80401 7.80401C7.9295 7.67851 8 7.50831 8 7.33083C8 7.15336 7.9295 6.98315 7.80401 6.85766L2.27256 1.33288H7.33083C7.50758 1.33288 7.6771 1.26266 7.80208 1.13768C7.92706 1.0127 7.99727 0.84319 7.99727 0.666439C7.99727 0.489688 7.92706 0.320176 7.80208 0.195195C7.6771 0.0702133 7.50758 0 7.33083 0H0.666439C0.57935 0.00105286 0.493314 0.0191655 0.413193 0.0533147C0.250349 0.120942 0.120942 0.250349 0.0533147 0.413193C0.0191655 0.493314 0.00105286 0.57935 0 0.666439V7.33083C0 7.50758 0.0702133 7.6771 0.195195 7.80208C0.320176 7.92706 0.489688 7.99727 0.666439 7.99727Z"
              fill="#B4BDC8"
            />
          </svg>
          Outgoing
        </button>
      </div> */}

          <div className="flex justify-between items-center pt-4 space-x-4">
            <div className="bg-light-white rounded-md w-full h-16 pt-2">
              <h1 className="text-center font-bold text-lg text-gray-700">
                {LiveCalls?.live_calls?.total_calls || 0}
              </h1>
              <p className="text-center text-sm text-gray-700">Total Calls</p>
            </div>
            <div className="bg-light-white rounded-md w-full h-16 pt-2">
              <h1 className="text-center font-bold text-lg text-gray-700">
                {LiveCalls?.live_calls.talking || 0}
              </h1>
              <p className="text-center text-sm text-gray-700">Talking</p>
            </div>
          </div>
          {/* <div className="flex justify-between items-center pt-4 space-x-4">
          <div className="bg-light-white rounded-md w-full h-16 pt-2">
            <h1 className="text-center font-bold text-lg text-gray-700	">55</h1>
            <p className="text-center text-sm text-gray-700	">In queue</p>
          </div>
          <div className="bg-light-white rounded-md w-full h-16 pt-2">
            <h1 className="text-center font-bold text-lg text-gray-700	">190</h1>
            <p className="text-center text-sm text-gray-700	">Holding</p>
          </div>
          <div className="bg-light-white rounded-md w-full h-16 pt-2">
            <h1 className="text-center font-bold text-lg text-gray-700	">88</h1>
            <p className="text-center text-sm text-gray-700	">In IVR</p>
          </div>
        </div> */}
        </div>

        <h1 className="font-bold text-[20px] pl-7">Call Logs</h1>

        <div className="overflow-x-auto no-scrollbar p-4">
          <table className="w-full">
            <tbody>
              {/* <tr className="text-[17px] font-karla text-gray-900  whitespace-nowrap">
                <td className="py-4 px-4">
                  <p>22-Nov-22,12:50:01</p>
                  <p className="text-gray-400 flex">
                    <svg
                      width="12"
                      height="14"
                      viewBox="0 0 14 16"
                      fill="gray"
                      xmlns="http://www.w3.org/2000/svg"
                      className="mt-1 mr-[4px]"
                    >
                      <path d="M12.2238 9.54928C12.0697 9.52442 11.9166 9.45001 11.7682 9.39056C11.4673 9.2723 11.1755 9.13266 10.8951 8.97272C10.5894 8.80354 10.2311 8.752 9.88921 8.82802C9.5473 8.90404 9.24589 9.10224 9.04299 9.3845L8.83729 9.67102C8.21623 9.18429 7.66416 8.6174 7.19589 7.98554C6.74113 7.34668 6.37257 6.65201 6.09952 5.91908L6.43987 5.77504C6.77537 5.67492 7.06156 5.45581 7.24336 5.15987C7.42517 4.86393 7.48975 4.51208 7.42467 4.17202C7.36243 3.85823 7.3213 3.54071 7.30156 3.22153C7.29288 3.05674 7.29007 2.9 7.29541 2.73747C7.29105 2.23637 7.10567 1.75332 6.77266 1.37532C6.43964 0.997324 5.98087 0.749211 5.47896 0.675665L3.37717 0.336771C3.08106 0.288632 2.77796 0.302847 2.48776 0.378483C2.19756 0.454119 1.9268 0.589469 1.69324 0.775661C1.45569 0.966463 1.26258 1.20559 1.12706 1.47674C0.991535 1.74789 0.916791 2.04469 0.90792 2.34691C0.797114 5.30355 1.68615 8.21219 3.43479 10.614C5.18343 13.0158 7.69214 14.7741 10.5652 15.6116C10.655 15.6331 10.7464 15.6478 10.8384 15.6556C11.3959 15.7455 11.9667 15.613 12.4253 15.2873C12.884 14.9616 13.1928 14.4693 13.284 13.9187L13.6278 11.8429C13.7005 11.359 13.6001 10.8651 13.3438 10.4465C13.0875 10.0278 12.6915 9.71056 12.2238 9.54928ZM11.8795 13.7562C11.8641 13.8567 11.8267 13.9527 11.7699 14.0375C11.7132 14.1223 11.6385 14.1939 11.5509 14.2473C11.4634 14.3008 11.3651 14.3348 11.263 14.3471C11.1608 14.3593 11.0572 14.3495 10.9592 14.3182C8.39916 13.5593 6.16409 11.9879 4.60014 9.84741C3.04076 7.68842 2.24861 5.08037 2.34719 2.42979C2.34878 2.32586 2.37375 2.22356 2.42029 2.13032C2.46684 2.03707 2.53379 1.95521 2.61631 1.89065C2.69326 1.82817 2.78265 1.78238 2.87869 1.75625C2.97472 1.73012 3.07524 1.72424 3.17371 1.73899L5.2755 2.07788C5.43902 2.10057 5.58939 2.17885 5.70074 2.29924C5.81209 2.41963 5.87745 2.5746 5.88557 2.73747C5.88227 2.93112 5.88636 3.12359 5.89784 3.31488C5.91836 3.69268 5.96671 4.06849 6.04249 4.43934L4.98716 4.73094C4.89701 4.75542 4.81263 4.79724 4.73887 4.85401C4.66512 4.91078 4.60344 4.98137 4.55738 5.06174C4.51132 5.14211 4.48179 5.23066 4.47048 5.32232C4.45916 5.41398 4.46629 5.50694 4.49146 5.59585C5.14649 7.89148 6.59862 9.88605 8.59346 11.2301C8.75257 11.3268 8.94389 11.3577 9.12592 11.316C9.31035 11.2801 9.47288 11.1735 9.57784 11.0194L10.1797 10.1219C10.5207 10.3082 10.8727 10.4741 11.2339 10.6187C11.4092 10.6896 11.5996 10.7558 11.7842 10.814C11.9364 10.8746 12.0626 10.9855 12.1414 11.1277C12.2201 11.2699 12.2465 11.4347 12.216 11.594L11.8795 13.7562Z" />
                    </svg>
                    7584858596
                  </p>
                </td>
                <td className="px-4  py-4 text-center">
                  <p>Answered</p>
                  <p className="text-gray-400">Anjali</p>
                </td>
                <td className="p-3">00:01:41</td>
              </tr>  */}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
export default LiveCalls;
